import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class ForInvestorsItems extends ContentItem {
  constructor() {
    super({
        opertyResolver: fieldName => `_${fieldName}`
    });
  }
  get sectionHeader() {
    return get(this, 'header.value', '');
  }
  get sectionDescription() {
    return get(this, 'description.value', '');
  }
  get sectionsData() {
    return get(this, 'for_investors_sections', '');
  }


}



// WEBPACK FOOTER //
// ./src/models/ForInvestors.model.js